// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__MHcH1","content":"Header_content__6raEe","anchors":"Header_anchors__IsBFm","user":"Header_user__XTZer","search-active":"Header_search-active__OL3bh"};